import React from 'react';
import {findPage} from './permissionsConfig';

const PermissionChecker = ({ page, action, children }) => {
    const hasPermission = findPage(page);
    return hasPermission ? children : null;
};

export default PermissionChecker;
